import { connect } from 'react-redux';

const RenderProvider = ({ children, affiliateData }) => {
  const isAffiliateInvalid = () => {
    return affiliateData?.afiliado && !affiliateData?.isValid;
  };

  const affiliateNotExists = () => {
    return !affiliateData?.afiliado;
  };

  if (affiliateNotExists()) {
    return (
      <div className='px-3 mt-3'>
        <div data-test-id='affiliate-not-valid' className='alert alert-danger'>
          No se ha ingresado un afiliado. Por favor, ingrese el número de afiliado para continuar.
        </div>
      </div>
    );
  }

  if (isAffiliateInvalid()) {
    return (
      <div className='px-3 mt-3'>
        <div className='alert alert-danger'>
          El afiliado ingresado no es válido. Por favor, verifique la credencial ingresada.
        </div>
      </div>
    );
  }

  return children;
};

const mapStateToProps = (state) => ({
  affiliateData: state.affiliate?.data,
});

export default connect(mapStateToProps, {})(RenderProvider);
